// JavaScript Document


$(document).ready(function () {

var positionTop = $(window).scrollTop();	
	
// require(["fonctions/v3/ajaxMagie"], function (f) {
// f.iniAjaxForm();
// });
	

// $( "body" ).on("ajaxEnd postEnd","#outils",function(){
// // $(this).foundation();
// console.log('A');
// });
	// 	History.Adapter.bind(window,'statechange',function(){
	// 	// iniSwitch();
	// 	// $(".calculator-loan").accrue();
	
	// });
		


});
$( "body" ).on("ajaxEnd postEnd","#outils",function(){
    console.log('Outils ajaxEnd postEnd triggered');
// $(this).foundation();
	//iniShareReveal();

//	if($('html').hasClass('is-reveal-open')){
//		$("#outils-fiche-detail").foundation('close');
//	}

});
	
	// 	History.Adapter.bind(window,'statechange',function(){
	// 	console.log('State change detected');
	
	// });

  //jquery(document).ready(function(){

//   (function($) {
//     iniSwitch();
//   })(jQuery);
